// extracted by mini-css-extract-plugin
export default {"map":"styles_map__MJ+av","absolute":"styles_absolute__oViue"};